import React, {useState, useEffect, useRef} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faPhone, faBriefcase, faLightbulb, faUserGraduate, faUserShield, faSuitcase, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API_URL } from '../global/components/Constants';
import PageLoader from '../global/components/PageLoader';
import { getProfileBySlug } from '../utils/api-services/profile';
import ListDisplay from './components/ListDisplay';

function CvDetails() {

    const [cv, setCv] = useState(null);
    const [dob, setDob] = useState("");
    const [skills, setSkills] = useState([]);
    const [works, setWorks] = useState([]);
    const [educations, setEducations] = useState([]);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);

    const { code } = useParams();

    useEffect(()=>{
        loadProfile();
    }, []);

    const loadProfile = async () => {
        setLoading(true);
        const obj = await getProfileBySlug(code);
        if(obj?.Success){
            setCv(obj.Data);
            presetData(obj.Data);
        }
        setLoading(false);
    }

    function presetData(obj){
    
        if(obj.Dob != ""){
            const dob = JSON.parse(obj.Dob);
            setDob(`${dob.day} ${dob.month} ${dob.year}`);
        }

        const works = (obj.ExperienceWork != "")? JSON.parse(obj.ExperienceWork): [];
        const educations = (obj.Education != "")? JSON.parse(obj.Education): [];
        const skills = (obj.Skills != "")? JSON.parse(obj.Skills): [];
        const projects = (obj.Projects != "")? JSON.parse(obj.Projects): [];
    
        setWorks(works);
        setEducations(educations);
        setSkills(skills);
        setProjects(projects);
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        body:{
            display: 'flex',
            alignItems: 'stretch',
            flexWrap: 'wrap',
            border: '1px solid #4a90e2'
        },
        profile:{
            wrap:{
                flex: 1,
                background: '#eaf2ea',
                minWidth: 300,
                minHeight: 200
            },
            body:{
                padding: '30px 20px',
            }
        },
        content:{
            wrap:{
                flex: 3,
                background: '#fff',
            },
            body:{
                padding: '30px 20px',
            }
        },
        who:{
            wrap:{
                marginBottom: 50
            },
            photo:{
                wrap:{
                    marginBottom: 10,
                    textAlign: 'center',
                },
                img:{
                    width: 160,
                    borderRadius: 5
                },
                holder:{
                    background: '#fff',
                    color: '#ccc',
                    width: 160,
                    height: 180,
                    fontSize: 100,
                    borderRadius: 5
                }
            },
            name:{
                color: '#333',
                marginBottom: 3,
                textAlign: 'center',
                fontSize:22,
                fontWeight: 500
            },
            about:{
                color: '#333',
                marginBottom: 60,
                fontSize:16,
                fontWeight: 500
            },
            profession:{
                color: '#333',
                textAlign: 'center',
                fontSize:16,
                fontWeight: 500
            },
            dob:{
                color: '#333',
                textAlign: 'center',
                fontSize:14,
                fontWeight: 500
            },
            availability:{
                color: '#333',
                textAlign: 'center',
                fontSize:14,
                fontWeight: 500
            },
        },
        section:{
            wrap: {
                marginBottom: 80
            },
            head:{
                display: 'flex',
            },
            icon: {
                width: '36px',
                height: '40px',
                marginRight: 10,
                borderRadius: '50%',
                backgroundColor: '#4a90e2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '18px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            },
            titleWrap:{
                width: '100%'
            },
            title:{
                color: '#333',
                marginBottom: 10,
                fontSize:16,
                fontWeight: 500
            },
            hr:{
                borderColor: '#4a90e2'
            },
            item:{

            },
            label:{
                color: '#333',
                marginBottom: 10,
                fontSize:14,
                fontWeight: 500
            },
            value:{
                color: '#333',
                marginBottom: 10,
                fontSize:14,
            }
        },
    }

    function sectionHead(icon, label){
        return (
            <div style={styles.section.head}>
                <div style={styles.section.icon}><FontAwesomeIcon icon={icon} /></div>
                <div style={styles.section.titleWrap}>
                    <div style={styles.section.title}>{label}</div>
                    <hr style={styles.section.hr} />
                </div>
            </div>
        )
    }

    const profile = (
        <div style={styles.profile.body}>

            <div style={styles.who.photo.wrap}> 
                {(cv?.Photo != "")?
                    <img src={`${API_URL}uploads/profile/photo/${cv?.Photo}`} style={styles.who.photo.img} />:
                    <button style={styles.who.photo.holder}>
                        <FontAwesomeIcon icon={faUser} />
                    </button>
                }
            </div>

            <div style={styles.who.wrap}>
                <h2 style={styles.who.name}>{cv?.Name}</h2>
                <div style={styles.who.profession}>{cv?.Profession}</div>
                <div style={styles.who.dob}>Date Of Birth: {dob}</div>
                <div style={styles.who.dob}>Availaility: {cv?.Availability}</div>
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faPhone, "CONTACT")}
                <div style={styles.section.item}>
                    <div style={styles.section.value}>{cv?.Phone}</div>
                </div>
                <div style={styles.section.item}>
                    <div style={styles.section.value}>{cv?.Email}</div>
                </div>
                <div style={styles.section.item}>
                    <div style={styles.section.value}>{cv?.Location}</div>
                </div>
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faBriefcase, "EXPERIENCE")}
                <div style={styles.section.item}>
                    <span style={styles.section.label}>Level: </span>
                    <span style={styles.section.value}>{cv?.ExperienceLevel}</span>
                </div>
                <div style={styles.section.item}>
                    <span style={styles.section.label}>Length: </span>
                    <span style={styles.section.value}>{cv?.ExperienceLength}</span>
                </div>
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faLightbulb, "SKILLS")}
                <ListDisplay type={"skills"} data={skills} />
            </div>
        </div>
    )

    const content = (
        <div style={styles.content.body}>

            <div style={styles.section.wrap}>
                {sectionHead(faUser, "ABOUT")}
                <div style={styles.who.about}>{cv?.About}</div>
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faUserShield, "WORK EXPERIENCE")}
                <ListDisplay type={"works"} data={works} />
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faUserGraduate, "EDUCATION")}
                <ListDisplay type={"educations"} data={educations} />
            </div>

            <div style={styles.section.wrap}>
                {sectionHead(faSuitcase, "PROJECTS")}
                <ListDisplay type={"projects"} data={projects} />
            </div>
        </div>
    )

    if(loading){
        return (
            <div style={{marginTop:120,marginBottom:30}}>
                <PageLoader />
            </div>
        )
    }
    else{
        return (
            <div style={styles.page}>
                <div className='container'>
                <div style={styles.body}>
                    <div style={styles.profile.wrap}>
                        {profile}
                    </div>
                    <div style={styles.content.wrap}>
                        {content}
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default CvDetails;